import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#0d1117] group-[.toaster]:text-[#e6e9ee] group-[.toaster]:border group-[.toaster]:border-[#282c34] group-[.toaster]:rounded-[14px] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[#8b919c]",
          actionButton:
            "group-[.toast]:bg-[rgba(61,219,169,0.1)] group-[.toast]:text-[#3ddba9] group-[.toast]:border group-[.toast]:border-[rgba(61,219,169,0.5)] group-[.toast]:rounded-full",
          cancelButton:
            "group-[.toast]:bg-[rgba(40,44,52,0.45)] group-[.toast]:text-[#8b919c] group-[.toast]:rounded-full",
          success: "group-[.toaster]:text-[#3ddba9]",
          error: "group-[.toaster]:text-[#f87171]",
          warning: "group-[.toaster]:text-[#f0b45a]",
          info: "group-[.toaster]:text-[#e6e9ee]",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
